<template>
  <div class="page-section landing-form-two">
    <div class="landing-banner">
      <div
        class="image"
        :class="animationClass"
        :style="landingBackground"></div>
    </div>

    <div class="container landing-container">
      <div :class="classes">
        <div class="text">
         <h1
            v-if="parse(item).heading"
            @click="highlightField('heading')">
            {{parse(item).heading}}
          </h1>

          <h2
            v-if="parse(item).sub_heading"
            @click="highlightField('sub heading')">
            {{parse(item).sub_heading}}
          </h2>

          <div class="landing-text" v-html="parse(item).content" @click="highlightField('content')"></div>
        </div>

        <div class="fields-inner">
          <Field
            :isPreviewing="true"
            label="Name"
            type="text"
          />

          <Field
            :isPreviewing="true"
            label="Email Address"
            type="email"
          />

          <Field
            v-if="displayPhoneField"
            :isPreviewing="true"
            label="Phone Number"
            type="text"
          />

          <Field
            v-for="item in fields"
            :key="item.id"
            :placeholder="fieldPlaceholder(item)"
            :isPreviewing="true"
            :label="parse(item).label"
            :type="fieldType(parse(item).field_type)"
            :options="selectOptions(parse(item).dropdown_options)"
            :disableEditor="true">
          </Field>

          <div class="centered">
            <Btn @click="sendMessage" class="is-dark">Send Message</Btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

import parseComponent from '@/mixins/parseComponent'

import Btn from '@/components/Btn'
import Field from '@/components/Field'

export default {
  name: 'landing-form',

  mixins: [parseComponent],

  components: {
    Field,
    Btn
  },

  props: {
    title: String,
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  data() {
    return {
      contact: {},
      contacted: false
    }
  },

  computed: {
    ...mapGetters(['siteId']),
    ...mapState(['site']),

    displayPhoneField() {
      return this.parse(this.item).display_phone_field === 'true'
    },

    fieldPlaceholder() {
      return (field) => {
        const isText = field.value.field_type === 'form-text'

        return isText
          ? field.value.text_placeholder
          : field.value.text_box_placeholder
      }
    },

    fieldType() {
      return (type) => {
        return type.replace('form-', '')
      }
    },

    animationClass() {
      return [
        'landing-animation',
        this.parse(this.item).image_animation ? `animate-${this.parse(this.item).image_animation}` : ''
      ]
    },

    selectOptions() {
      return (options) => {
        if (options) {
          let array = []

          let newOptions = options.split(',')

          newOptions.forEach((option) => {
            array.push({key: option, value: option})
          })

          return array
        }
      }
    },

    landingBackground() {
      let image = this.demoMode ? this.parse(this.item).image_url : this.item.image_versions[0].url
      return `background-image:url('${image}')`
    },

    classes() {
      return [
        'landing-content',
        this.parse(this.item).text_position_desktop,
        this.parse(this.item).text_position_mobile,
        this.parse(this.item).text_width_desktop,
        this.parse(this.item).text_alignment || 'align-middle'
      ]
    },

    item() {
      return this.items[0] || {}
    },

    messageParams() {
      return {
        message: this.contact
      }
    },

    friendlyTypes() {
      return (type) => {
        if (type.includes('textarea')) {
          return 'form-textarea'
        } else if (type.includes('text')) {
          return 'form-text'
        } else if (type.includes('select')) {
          return 'form-select'
        } else {
          return 'form-checkbox'
        }
      }
    },

    fields() {
      let objects = this.parse(this.items[0])
      let fields = []

      Object.entries(objects).forEach(([key, value]) => {
        if (key.includes('custom_field_label')) {
          let index = key.slice(-1)

          let object = {
            label: objects[`custom_field_label_${index}`],
            field_type: this.friendlyTypes(objects[`custom_field_type_${index}`]),
            dropdown_options: objects[`custom_field_options_${index}`],
            text_placeholder: objects[`custom_field_text_placeholder_${index}`],
            text_box_placeholder: objects[`custom_field_text_box_placeholder_${index}`]
          }

          if (value !== '') {
            fields.push({value: object})
          }
        }
      })

      return fields || []
    }
  },

  methods: {
    sendMessage() {
      alert('The information submitted will be sent to your email address.')
    }
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/helpers/mixins'
@import '../../../stylesheets/helpers/extends'
@import '../../../stylesheets/base/theme'

.landing-form-two
  &.page-section
    padding-top: 0!important
    padding-left: 0!important
    padding-right: 0!important

  .btn
    margin: 0 auto 30px
    display: block
    padding: 15px 25px

  .landing-content
    display: flex
    flex-direction: column
    padding: $gap-small
    flex: 1

    .text
      padding: $gap-small
      position: relative
      transition: all .3s ease-in-out

      @include media($media-gt-small)
        padding: $gap-medium
        margin: $gap-small 0 $gap-small $gap-small

      p, h1, h2, h3
        color: #fff!important

      h1, h2
        margin: $gap-x-small 0

    .landing-text
      position: relative

      @include media($media-gt-small)
        top: $gap-medium

    @include media($media-lt-small)
      &.text-below
        flex-direction: column-reverse

    @include media($media-gt-small)
      flex-direction: row

      &.text-right
        flex-direction: row-reverse

      &.one-third
        .text
          flex-basis: percentage(1/3)

      &.half
        .text
          flex-basis: percentage(1/2)

      &.two-thirds
        .text
          flex-basis: percentage(2/3)

      &.three-fifths
        .text
          flex-basis: percentage(3/5)

      &.align-top
        .text
          align-items: top

      &.align-middle
        .text
          align-items: center

      &.align-bottom
        .text
          align-items: flex-end

  .form-contact
    background: none!important
    box-shadow: none!important

  .form-container
    padding-top: 0

  .simple-form-fields
    flex: 1

  .landing-container
    position: absolute
    top: $gap-medium
    right: $gap-medium
    padding: $gap-medium 0
    z-index: 10

    .fields-inner
      background: #fff
      border-radius: 10px
      flex: 1
      padding: $gap-medium

      .input
        margin: 0 0 15px!important

  .landing-banner
    position: relative
    display: flex
    align-items: center
    justify-content: center
    overflow: hidden
    min-height: 85vh

    &:before
      content: ''
      position: absolute
      width: 100%
      height: 100%
      top: 0
      left: 0
      pointer-events: none
      z-index: 1
      background: rgba(0, 0, 0, 0.5)

    .loader
      display: none

    .banner-inner
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column
      text-align: center
      z-index: 5

      h1, h2, h3, p, span
        color: #fff!important

      h1, h2, h3
        margin: $gap-small 0
        line-height: 1

      h1
        font-size: 56px

      h2
        font-size: 32px

    .image
      background-position: 50% 50%
      background-size: cover
      transition: max-height .3s ease-in-out
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%

  .overlay
    .inner
      max-width: 500px

    p, h2
      text-align: center
</style>
